import { FC } from "react";
import { useParams } from "react-router-dom";
import { ViewAddEdit } from "./components/ViewAddEdit";
import { PageLink, PageTitle } from "../../../_metronic/layout/core";
import { decryptId } from "../../../_metronic/helpers";

const CollaboratorAddEdit: FC = () => {
  const { id } = useParams<{ id: string }>();
  const idRegister = decryptId(id);
  const breadCrumbs: Array<PageLink> = [
    {
      title: "Colaboradores",
      path: "/recursos_humanos/colaboradores",
      isSeparator: false,
      isActive: false,
    },
    {
      title: "",
      path: "",
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>
        {idRegister ? "Editar colaborador" : "Nuevo colaborador"}
      </PageTitle>
      <ViewAddEdit
        id={idRegister ? idRegister : "0"}
      />
    </>
  );
};

export { CollaboratorAddEdit };
